import React from "react"

import { withCallToAction } from "./withCallToAction"
import { Icon } from "../../Icon/Icon"
import { StyledContainer } from "../../Styled/Container"
import { Section, Title, Subtitle, Image, Overlay, Content, Button, ButtonOuter, ButtonText, Player } from "./CallToActionStyles"

export const CallToAction = withCallToAction(
  ({ title, content, handlePlayed, handleVideo, play, played, theme, video, additionalPlayButton }): JSX.Element => (
    <Section theme={theme} simple={!video}>
      {video && played && (
        <>
          <Player
            width={`100%`}
            height={`100%`}
            onPlay={() => handleVideo(true)}
            onPause={() => handleVideo(false)}
            onEnded={handlePlayed}
            playing={play || false}
            url={video.asset?.url}
          />
          <ButtonOuter active={play}>
            <Button hover onClick={() => handleVideo(false)} title={`Pause`}>
              <Icon name={`pause`} width={70} title={`Pause`} />
            </Button>
          </ButtonOuter>
        </>
      )}

      {video?.poster?.desktop && <Image active={!play} alt={video?.poster?.desktop?.alt} fluid={video?.poster?.desktop} screen={`md>`} />}
      {video?.poster?.mobile && <Image active={!play} alt={video?.poster?.mobile?.alt} fluid={video?.poster?.mobile} screen={`<sm`} />}
      {video?.poster && <Overlay active={!play} />}

      <StyledContainer width={`lg`}>
        <Content active={!play}>
          {title && (
            <Title align={`center`} italic large={video}>
              {title}
            </Title>
          )}
          {video && (
            <Button onClick={handleVideo} title={additionalPlayButton}>
              <Icon name={`play`} width={60} title={additionalPlayButton} />
              <ButtonText>{additionalPlayButton}</ButtonText>
            </Button>
          )}
          {content && (
            <Subtitle align={`center`} normal>
              {content}
            </Subtitle>
          )}
        </Content>
      </StyledContainer>
    </Section>
  )
)

export default CallToAction
